<template>
  <div>
    <v-row no-gutters style="padding: 0">
      <v-col v-if="wWidth > 992" cols="12" style="padding: 0">
        <v-container
          id="testhtml"
          ref="testHtml"
          style="
            background: white;
            border-radius: 5px;
            position: relative;
            width: 100%;
          "
          v-if="result != null"
        >
          <v-card flat>
            <div style="height: 20px; position: relative">
              <v-btn
                :loading="loading"
                :disabled="loading"
                @click="close"
                x-small
                outlined
                class="black--text font-weight-bold"
                style="
                  font-size: 10px;
                  position: absolute;
                  right: -115px;
                  top: -5px;
                "
              >
                <v-icon x-small>mdi-chevron-left</v-icon>
                Kembali
              </v-btn>
            </div>
            <div
              style="
                z-index: 2;
                position: sticky;
                top: 0;
                background: white;
                border-bottom: 1px solid black;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-left: 10px;
                "
              >
                <v-toolbar-title class="overline">
                  <p style="font-size: 20px; margin: 0; font-weight: bold">
                    Detail Pemakaian Aset
                    <v-tooltip bottom color="grey">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          text
                          icon
                          color="grey darken-2"
                          style="position: relative; top: -3px"
                          @click="getDetail()"
                        >
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>refresh page</span>
                    </v-tooltip>
                  </p>
                </v-toolbar-title>
              </div>
              <div class="d-flex">
                <div>
                  <div v-if="result.status == 1 && isAllow">
                    <v-btn
                      @click="approveUsage"
                      small
                      elevation="1"
                      outlined
                      color="green"
                      class="white--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                      @click="rejectUsage"
                      :loading="loading"
                      small
                      elevation="1"
                      outlined
                      color="red"
                      class="red--text font-weight-bold ma-2"
                      style="font-size: 12px"
                    >
                      Reject
                    </v-btn>
                  </div>
                </div>
                <div
                  v-if="
                    getUserProfile.employee.company.plant_id ==
                    result.company_id
                  "
                >
                  <div v-if="result.status == -2">
                    <!-- <v-btn
                      @click="setDraft"
                      small
                      elevation="1"
                      outlined
                      color="primary"
                      class="white--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Set Draft
                    </v-btn> -->
                  </div>
                </div>
                <div
                  v-if="
                    result.status == -1 ||
                    result.status == 0 ||
                    result.status == 1 ||
                    result.status == 2
                  "
                >
                  <div
                    class="d-flex"
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) != undefined
                    "
                  >
                    <div v-if="result.status == 0">
                      <!-- <v-btn
                        v-if="!isEdit"
                        @click="editHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Edit
                      </v-btn> -->
                      <v-btn
                        v-if="!isEdit"
                        @click="submitUsage"
                        small
                        elevation="1"
                        outlined
                        color="green"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="saveEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Simpan
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="cancelEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="red"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Batal Edit
                      </v-btn>
                      <!-- </div> -->
                    </div>

                    <v-dialog
                      v-if="result.status == 0 || result.status == 2"
                      v-model="dialog2"
                      persistent
                      width="760"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="
                            (result.status == -1 || result.status == 0) &&
                            getUserProfile.employee.company.plant_id ==
                              result.company_id &&
                            !isEdit
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          outlined
                          elevation="1"
                          color="red"
                          class="red--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Batalkan
                        </v-btn>
                        <v-btn
                          v-if="
                            result.status == 2 &&
                            getUserProfile.employee.company.plant_id ==
                              result.company_id
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          elevation="1"
                          outlined
                          color="red"
                          class="white--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          {{ result.status != 2 ? 'Batalkan' : 'Kembalikan' }}
                        </v-btn>
                      </template>

                      <v-card style="padding: 20px" class="text-center">
                        <v-row>
                          <v-col cols="12" class="text-h5 font-weight-bold">
                            BERIKAN ALASAN !
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="reason"
                              auto-grow
                              outlined
                              clearable
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-btn
                              @click="cancelRequest"
                              rounded
                              elevation="1"
                              outlined
                              color="red"
                              class="red--text font-weight-bold ma-2"
                              style="font-size: 12px"
                              :loading="loading"
                            >
                              Batalkan
                            </v-btn>
                            <v-btn
                              @click="dialog2 = false"
                              rounded
                              elevation="1"
                              outlined
                              color="indigo"
                              class="indigo--text font-weight-bold ma-2"
                              style="font-size: 12px"
                            >
                              Tutup
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
          <v-row
            no-gutters
            v-if="result != null"
            style="position: relative; top: -13px"
          >
            <v-col cols="4">
              <p style="font-size: 12px">
                Tgl. Buat: {{ result.created_at }} |
                {{ result.created_by_name }}
              </p>
            </v-col>
            <v-col cols="8">
              <div class="d-flex justify-end">
                <p
                  :style="`background-color: ${statusColor(result.status)};
                  color: white;
                  font-weight: bold;
                  margin: 5px 0 0 0;
                  padding: 0 10px;
                  border: 1px solid rgba(0, 0, 0, 0.6);
                  width: 180px;
                  text-align: center;`"
                >
                  {{ usageStatus(result.status) }}
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row style="padding: 15px">
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No. Dokumen
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.doc_no"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    PIC Name
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.created_by_name"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.company_name"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
          </v-row>
          <v-row style="padding: 15px; margin-top: 10px">
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Pemakaian
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-if="!isEdit"
                    :value="result.planned_date"
                    clearable
                    dense
                    readonly
                    style="margin: 0"
                  />
                  <v-text-field
                    v-else
                    v-model="result.planned_date"
                    clearable
                    :outlined="isEdit"
                    dense
                    :readonly="!isEdit"
                    type="date"
                    name="date"
                    step="1"
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <!-- <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Aktual
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-if="!isEdit"
                    :value="result.actual_date"
                    clearable
                    dense
                    readonly
                    style="margin: 0"
                  />
                  <v-text-field
                    v-else
                    v-model="result.actual_date"
                    clearable
                    :outlined="isEdit"
                    dense
                    :readonly="!isEdit"
                    type="date"
                    name="date"
                    step="1"
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col> -->
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Lokasi Pemakaian
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-if="!isEdit"
                    :value="result.usage_location"
                    dense
                    readonly
                    style="margin: 0"
                  />
                  <v-text-field
                    v-else
                    v-model="result.usage_location"
                    clearable
                    :outlined="isEdit"
                    dense
                    :readonly="!isEdit"
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
          </v-row>

          <v-row style="padding: 15px">
            <v-col cols="12">
              <v-row no-gutters dense>
                <v-col cols="4" md="2" v-if="isEdit">
                  <v-btn
                    elevation="2"
                    small
                    @click="addItem"
                    rounded
                    outlined
                    color="indigo"
                    class="indigo--text font-weight-bold ma-2"
                    style="font-size: 12px"
                  >
                    add item</v-btn
                  >
                </v-col>
                <v-col cols="4" md="2" style="margin-left: auto">
                  <v-btn
                    elevation="0"
                    color="transparent"
                    small
                    outlined
                    style="margin-right: 10px"
                    :loading="loading"
                    @click="downloadDokumen"
                  >
                    <v-icon color="primary" small style="margin-right: 5px"
                      >mdi-file-outline</v-icon
                    >
                    <a href="#" style="font-weight: bold">File Pendukung</a>
                  </v-btn>
                </v-col>
                <!-- <v-col cols="4" md="2">
                  <v-btn
                    elevation="0"
                    color="transparent"
                    small
                    outlined
                    style="margin-right: 10px"
                    :loading="loading"
                    @click="generatePdfDokumen"
                  >
                    <v-icon color="primary" small style="margin-right: 5px"
                      >mdi-printer
                    </v-icon>
                    <a href="#" style="font-weight: bold">Print Dokumen</a>
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-col>
            <v-col md="12" style="padding: 0 10px">
              <v-data-table
                mobile-breakpoint="0"
                :items="result ? result.items : []"
                :headers="headers"
                @click:row="rowClick"
                class="elevation-1 mx-auto"
                style="
                  cursor: pointer;
                  margin-bottom: 10px;
                  border: 1px solid #e0e0e0;
                "
                :items-per-page="10"
                hide-default-footer
              >
                <template v-slot:[`header.action`]>
                  <span>
                    Aksi
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="red lighten-2"
                          style="margin: 0"
                          x-small
                          @click="deleteAllItem"
                          :disabled="result != null && result.item.length == 0"
                        >
                          mdi-delete-circle
                        </v-icon>
                      </template>
                      <span>Delete All</span>
                    </v-tooltip>
                  </span>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div style="font-size: 12px; width: 210px; padding: 0">
                    <span>({{ item.asset_code }})</span>
                    {{ item.asset_name }}
                  </div>
                </template>
                <template v-slot:[`item.lot_no`]="{ item }">
                  <div style="font-size: 12px; width: 120px; padding: 0">
                    {{ item.lot_no }}
                  </div>
                </template>
                <template v-slot:[`item.qty_used`]="{ item }">
                  <div style="font-size: 12px; width: 40px; padding: 0">
                    {{ item.qty_used }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item, index }">
                  <div style="font-size: 12px; width: 40px; padding: 0">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          text
                          icon
                          x-small
                          color="red lighten-2"
                          @click="deleteItem(item, index)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row style="padding: 15px">
            <v-col md="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan Tambahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    v-model="result.description"
                    dense
                    auto-grow
                    outlined
                    :readonly="!isEdit"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col v-if="result.status == -2" md="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Alasan pembatalan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    outlined
                    :value="result.confirm_note || '-'"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
          </v-row>
          <hr />
          <div v-if="result.approval_matrix != null">
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 10px;
              "
            >
              <v-toolbar-title class="overline">
                <p style="font-size: 16px; margin: 0; font-weight: bold">
                  Approval
                </p>
              </v-toolbar-title>
            </div>
            <v-row style="padding: 15px">
              <v-col md="12" style="padding: 0">
                <v-data-table
                  mobile-breakpoint="0"
                  :headers="approvalHeaders"
                  :items="matrix"
                  :items-per-page="10"
                  class="elevation-1 mx-auto"
                  style="
                    width: 99%;
                    margin-bottom: 10px;
                    border: 1px solid #e0e0e0;
                  "
                  hide-default-footer
                >
                  <template v-slot:[`item.approver_user`]="{ item }">
                    <div style="cursor: pointer" v-if="item">
                      <v-chip
                        label
                        outlined
                        small
                        style="
                          margin-right: 5px;
                          padding: 0 3px;
                          cursor: pointer;
                          border: 1px solid rgba(0, 0, 0, 0.5);
                        "
                        v-for="(item, index) in item.approver_user"
                        :key="index"
                      >
                        {{ item.user.name }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:[`item.approved`]="{ item }">
                    <div
                      v-for="(items, index) in item.approver_user"
                      :key="index"
                    >
                      <v-chip
                        v-if="items.status == 1"
                        label
                        outlined
                        small
                        style="
                          margin-right: 5px;
                          padding: 0 3px;
                          cursor: pointer;
                          border: 1px solid rgba(0, 0, 0, 0.5);
                        "
                      >
                        {{ items.user.name }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:[`item.rejected`]="{ item }">
                    <div
                      v-for="(items, index) in item.approver_user"
                      :key="index"
                    >
                      <v-chip
                        v-if="items.status == -1"
                        label
                        outlined
                        small
                        style="
                          margin-right: 5px;
                          padding: 0 3px;
                          cursor: pointer;
                          border: 1px solid rgba(0, 0, 0, 0.5);
                        "
                      >
                        {{ items.user.name }}
                      </v-chip>
                    </div>
                  </template>
                </v-data-table>
                <div style="text-align: right; padding-right: 5px">
                  <v-btn
                    v-if="
                      result.status == 1 &&
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) != undefined
                    "
                    color="grey"
                    tile
                    dark
                    small
                    dense
                    style="font-size: 10px; width: 100px"
                    @click="fetchApproval"
                    :loading="loading"
                  >
                    <span>Fetch Matrix</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-col>
      <v-col v-if="wWidth < 992" cols="12" style="padding: 0">
        <v-container
          style="
            width: 100%;
            height: 92vh;
            overflow: auto;
            margin: auto;
            border-radius: 5px;
            background: rgba(255, 255, 255, 0.9);
            padding: 5px 15px 15px 15px;
          "
        >
          <v-btn
            @click="close"
            x-small
            outlined
            class="black--text font-weight-bold"
            style="
              font-size: 10px;
              position: absolute;
              right: 15px;
              top: 2px;
              z-index: 5;
            "
            :loading="loading"
          >
            <v-icon x-small>mdi-chevron-left</v-icon>
            Kembali
          </v-btn>
          <v-row
            no-gutters
            style="
              width: 100%;
              position: fixed;
              bottom: 0;
              left: 0;
              z-index: 2;
              background: white;
            "
          >
            <v-col
              cols="12"
              class="d-flex"
              style="position: relative; padding: 0 20px; text-align: center"
            >
              <h5 style="font-weight: bold; margin: auto"></h5>
            </v-col>
            <div style="width: 100%">
              <div
                v-if="result != null"
                class="d-flex justify-center align-center"
                style="width: 100%; background: white"
              >
                <div>
                  <div v-if="result.status == 1 && isAllow">
                    <v-btn
                      @click="approveUsage"
                      :loading="loading"
                      small
                      elevation="1"
                      outlined
                      color="green"
                      class="green--text font-weight-bold ma-2"
                      style="font-size: 12px"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                      @click="rejectUsage"
                      :loading="loading"
                      small
                      elevation="1"
                      outlined
                      color="red"
                      class="red--text font-weight-bold ma-2"
                      style="font-size: 12px"
                    >
                      Reject
                    </v-btn>
                    <!-- </div> -->
                  </div>
                </div>
                <div
                  v-if="
                    result.status == -1 ||
                    result.status == 0 ||
                    result.status == 1 ||
                    result.status == 2
                  "
                >
                  <div
                    class="d-flex"
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) != undefined
                    "
                  >
                    <div v-if="result.status == 0">
                      <v-btn
                        v-if="!isEdit"
                        @click="submitUsage"
                        small
                        elevation="1"
                        outlined
                        color="green"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="saveEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Simpan
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="cancelEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="red"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Batal Edit
                      </v-btn>
                      <!-- </div> -->
                    </div>
                    <v-dialog v-model="dialog2" persistent width="760">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="
                            (result.status == -1 ||
                              result.status == 0 ||
                              result.status == 2) &&
                            getUserProfile.employee.company.plant_id ==
                              result.company_id
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          outlined
                          elevation="1"
                          color="red"
                          class="red--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          {{ result.status != 2 ? 'Batalkan' : 'Kembalikan' }}
                        </v-btn>
                      </template>

                      <v-card style="padding: 20px" class="text-center">
                        <v-row>
                          <v-col cols="12" class="text-h5 font-weight-bold">
                            BERIKAN ALASAN !
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="reason"
                              auto-grow
                              outlined
                              clearable
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-btn
                              @click="cancelRequest"
                              rounded
                              elevation="1"
                              outlined
                              color="red"
                              class="red--text font-weight-bold ma-2"
                              style="font-size: 12px"
                              :loading="loading"
                            >
                              Batalkan
                            </v-btn>
                            <v-btn
                              @click="dialog2 = false"
                              rounded
                              elevation="1"
                              outlined
                              color="indigo"
                              class="indigo--text font-weight-bold ma-2"
                              style="font-size: 12px"
                            >
                              Tutup
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </div>
                </div>
                <!-- <div v-if="result.status == 2">
                  <div>
                    <v-btn
                      @click="generatePdfDokumen"
                      small
                      outlined
                      elevation="1"
                      color="indigo"
                      class="indigo--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Lihat PDF
                    </v-btn>
                  </div>
                </div> -->
              </div>
            </div>
          </v-row>
          <v-expansion-panels
            v-model="panel"
            multiple
            class="mb-1 mt-5"
            elevation="1"
          >
            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
                >Informasi Pemakaian
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="result != null">
                  <v-row no-gutters style="padding: 0">
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            No. Dokumen
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            :value="result.doc_no"
                            dense
                            readonly
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            PIC Name
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            :value="result.created_by_name"
                            dense
                            readonly
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Perusahaan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            :value="result.company_name"
                            dense
                            readonly
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Tgl. Pemakaian
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            v-if="!isEdit"
                            :value="result.planned_date"
                            clearable
                            dense
                            readonly
                            style="margin: 0"
                          />
                          <v-text-field
                            v-else
                            v-model="result.planned_date"
                            clearable
                            :outlined="isEdit"
                            dense
                            :readonly="!isEdit"
                            type="date"
                            name="date"
                            step="1"
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <!-- <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Tgl. Aktual
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            v-if="!isEdit"
                            :value="result.actual_date"
                            clearable
                            dense
                            readonly
                            style="margin: 0"
                          />
                          <v-text-field
                            v-else
                            v-model="result.actual_date"
                            clearable
                            :outlined="isEdit"
                            dense
                            :readonly="!isEdit"
                            type="date"
                            name="date"
                            step="1"
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col> -->
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Lokasi Pemakaian
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            v-if="!isEdit"
                            :value="result.usage_location"
                            dense
                            readonly
                            style="margin: 0"
                          />
                          <v-text-field
                            v-else
                            v-model="result.usage_location"
                            clearable
                            :outlined="isEdit"
                            dense
                            :readonly="!isEdit"
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Keterangan Tambahan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-textarea
                            v-model="result.description"
                            dense
                            auto-grow
                            outlined
                            :readonly="!isEdit"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col
                      v-if="result.status == -2"
                      cols="12"
                      style="padding: 0"
                    >
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Alasan pembatalan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-textarea
                            outlined
                            :value="result.confirm_note || '-'"
                            dense
                            readonly
                            style="margin: 0"
                          />
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
                >Daftar Barang
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="result != null">
                  <v-row no-gutters style="padding: 0">
                    <v-col md="12" style="padding: 0">
                      <v-data-table
                        :items="result ? result.items : []"
                        :headers="headers"
                        @click:row="rowClick"
                        class="elevation-1 mx-auto"
                        style="
                          cursor: pointer;
                          margin-bottom: 10px;
                          border: 1px solid #e0e0e0;
                        "
                        :items-per-page="10"
                        hide-default-footer
                      >
                        <template v-slot:[`header.action`]>
                          <span>
                            Aksi
                            <v-tooltip bottom>
                              <template v-slot:activator="{ attrs, on }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="red lighten-2"
                                  style="margin: 0"
                                  x-small
                                  @click="deleteAllItem"
                                  :disabled="
                                    result != null && result.item.length == 0
                                  "
                                >
                                  mdi-delete-circle
                                </v-icon>
                              </template>
                              <span>Delete All</span>
                            </v-tooltip>
                          </span>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                          <div
                            style="font-size: 12px; width: 210px; padding: 0"
                          >
                            <span>({{ item.asset_code }})</span>
                            {{ item.asset_name }}
                          </div>
                        </template>
                        <template v-slot:[`item.lot_no`]="{ item }">
                          <div
                            style="font-size: 12px; width: 120px; padding: 0"
                          >
                            {{ item.lot_no }}
                          </div>
                        </template>
                        <template v-slot:[`item.qty_used`]="{ item }">
                          <div style="font-size: 12px; width: 40px; padding: 0">
                            {{ item.qty_used }}
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ item, index }">
                          <div style="font-size: 12px; width: 40px; padding: 0">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  text
                                  icon
                                  x-small
                                  color="red lighten-2"
                                  @click="deleteItem(item, index)"
                                >
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel style="margin-bottom: 50px">
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
                >Approval
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="result != null">
                  <v-row no-gutters style="padding: 0">
                    <v-col md="12" style="padding: 0">
                      <v-data-table
                        mobile-breakpoint="0"
                        :headers="approvalHeaders"
                        :items="matrix"
                        :loading="matrix.length == 0"
                        :items-per-page="10"
                        class="elevation-1 mx-auto"
                        style="
                          width: 99%;
                          margin-bottom: 10px;
                          border: 1px solid #e0e0e0;
                        "
                        hide-default-footer
                      >
                        <template v-slot:[`item.approver_user`]="{ item }">
                          <div style="cursor: pointer" v-if="item">
                            <v-chip
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                              v-for="(item, index) in item.approver_user"
                              :key="index"
                            >
                              {{ item.user.name }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.approved`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                          >
                            <v-chip
                              v-if="items.status == 1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ items.user.name }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.rejected`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                          >
                            <v-chip
                              v-if="items.status == -1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ items.user.name }}
                            </v-chip>
                          </div>
                        </template>
                      </v-data-table>
                      <!-- <div style="text-align: right; padding-right: 5px">
                        <v-btn
                          v-if="
                            result.status == 1 &&
                            getUserProfile.level.find(
                              ({ id }) => id === '1' || id === '29'
                            ) != undefined
                          "
                          color="grey"
                          tile
                          dark
                          small
                          dense
                          style="font-size: 10px; width: 100px"
                          @click="fetchApproval"
                          :loading="loading"
                        >
                          <span>Fetch Matrix</span>
                        </v-btn>
                      </div> -->
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-col>
    </v-row>
    <div v-if="result != null">
      <add-item
        @getLot="initLot"
        :detail="result"
        :lotHeaders="headers"
        :dropdownCompany="dropdownCompany"
      />
    </div>

    <!-- DOKUMEN DIALOG -->
    <v-dialog
      v-if="result != null"
      v-model="dokumenDialog"
      width="500"
      persistent
    >
      <v-card style="position: relative">
        <v-card-title class="text-h5 grey lighten-2">
          Dokumen Pendukung
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <v-data-table
              v-if="result.file != null"
              mobile-breakpoint="0"
              fixed-header
              height="300"
              style="cursor: pointer"
              :headers="documentHeaders"
              :items="result.file"
              @click:row="readyToDownload"
              hide-default-footer
            >
              <template v-slot:[`item.subject`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.subject !== null
                      ? item.subject !== ''
                        ? item.subject
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  <v-btn
                    icon
                    x-small
                    @click.stop="
                      unlinkDokumen(
                        item.file.slice(item.file.lastIndexOf('/') + 1)
                      )
                    "
                    style="margin-right: 5px"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click.stop="readyToDownload(item)">
                    <v-icon color="green">mdi-download</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>

            <v-btn
              elevation="0"
              style="margin-right: auto; width: 100%"
              :loading="loading"
              color="primary"
              @click="uploadDoc('upload')"
            >
              <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
              <span :style="`font-weight: bold; color:white;`"
                >Tambah Dokumen</span
              >
            </v-btn>
          </v-col>
        </v-card-text>
        <!-- <v-btn icon color="black" text @click="closeDokumenDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="error"
            text
            outlined
            @click="closeDokumenDialog"
            :loading="loading"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            outlined
            :loading="loading"
            @click="deleteAllFile"
          >
            Delete all File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fileUploadDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        lazy-validation
        ref="entryFormUpload"
        @submit.prevent="submitUploadDoc"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> UPLOAD </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Subject
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-text-field
                      outlined
                      v-model="file_subject"
                      dense
                      :rules="rules.subjectRules"
                    ></v-text-field>
                  </div>
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.docRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeFileUpload"
              color="error"
              text
              outlined
              type="reset"
              @click="uploadDoc('close')"
              :loading="loading"
            >
              close
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
              :disabled="fileNameUpload === '' || file_subject === ''"
            >
              simpan file
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
import { globalMixin } from '../../../mixin/globalMixin'
export default {
  name: 'Usage-Detail',
  components: {
    AddItem: () => import('./components/AddItem.vue')
  },
  mixins: [globalMixin],
  data() {
    return {
      uploadApi: buildType.apiURL('upload2'),
      oAuth: buildType.apiURL('oauth'),
      asset: buildType.apiURL('asset'),
      panel: [0, 1],
      dialog: false,
      dialog2: false,
      form: {},
      loading: false,
      result: null,
      reason: '',
      isEdit: false,

      isAllow: false,
      matrix: [],
      wWidth: window.innerWidth,
      lot_item: null,
      usageId: null,
      dropdownCompany: [],

      file_subject: null,
      fileNameUpload: '',
      dokumenDialog: false,
      fileUploadDialog: false,
      rules: {
        docRules: [],
        subjectRules: []
      }
    }
  },
  mounted() {
    this.getDetail()
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters(['getUserProfile']),

    headers() {
      const xArrHeader = []
      if (this.isEdit) {
        xArrHeader.push({
          text: 'Aksi',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      xArrHeader.push(
        {
          text: 'Nama Aset',
          value: 'name',
          align: 'left',
          sortable: false
        },
        { text: 'No. Lot', value: 'lot_no', align: 'left', sortable: false },
        {
          text: 'Digunakan',
          value: 'qty_used',
          align: 'left',
          sortable: false
        }
      )
      return xArrHeader
    },
    approvalHeaders() {
      const xArrHeader = [
        { text: 'Sequence', value: 'sequence', align: 'left' },
        { text: 'Doc. No', value: 'document_no', align: 'left' },
        { text: 'Model', value: 'table_name', align: 'center' },
        { text: 'User', value: 'approver_user', align: 'center' },
        { text: 'Min. Approver', value: 'min_approver', align: 'center' },
        { text: 'Approved by', value: 'approved', align: 'center' },
        { text: 'Rejected by', value: 'rejected', align: 'center' }
      ]
      return xArrHeader
    },
    documentHeaders() {
      return [
        {
          text: 'File Name',
          value: 'subject',
          align: 'left',
          sortable: false,
          width: '90%'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'documentAuthority',
      'approvalMatrixDocumentList',
      'fetchMatrix'
    ]),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    onResize() {
      this.wWidth = window.innerWidth
    },

    generatePdfDokumen() {
      this.generatePDF(
        `${this.asset}usage/export_to_pdf/${this.$route.params.id}`,
        axios
      )
    },
    downloadDokumen() {
      setTimeout(() => {
        this.dokumenDialog = true
      }, 300)
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    unlinkDokumen(fName, pValue) {
      this.loading = true
      const data = {
        module: 'usage',
        file_name: fName
      }
      axios
        .post(`${this.uploadApi}esanqua/ams/unlink`, data)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.fileNameUpload = ''
            if (pValue === undefined) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue === undefined) {
              if (res.data.status_msg === 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      console.log(fName)
      for (let i = 0; i < this.result.file.length; i++) {
        if (this.result.file[i].file.includes(fName)) {
          this.result.file.splice(i, 1)
        }
      }
      this.updatePhoto(false)
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            file: []
          }
          await axios
            .post(`${this.asset}usage/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.dokumenDialog = false
              }, 300)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    closeDokumenDialog() {
      setTimeout(() => {
        this.dokumenDialog = false
      }, 300)
    },

    uploadDoc(event) {
      if (event === 'upload') {
        setTimeout(() => {
          this.fileUploadDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileNameUpload !== '') {
          let fName = ''
          fName = this.fileNameUpload
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload.reset()
        setTimeout(() => {
          this.fileUploadDialog = false
        }, 500)
      }
      this.fileNameUpload = ''
    },
    uploadFileDoc(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'usage')
          axios
            .post(`${this.uploadApi}esanqua/ams`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileNameUpload = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileNameUpload = ''
          }, 300)
        }
      } else {
        this.fileNameUpload = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },
    async updatePhoto(isAddFile) {
      const file = []
      if (this.result.file != null) {
        for (let i = 0; i < this.result.file.length; i++) {
          const fName = this.result.file[i].file.slice(
            this.result.file[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.result.file[i].subject,
            file: fName,
            created_by: this.result.file[i].created_by
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileNameUpload,
          created_by: this.getUserProfile.id
        })
      }
      const form = {
        id: this.$route.params.id,
        file: file
      }
      console.log('form', form)
      await axios
        .post(`${this.asset}usage/update_file_upload`, form)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameUpload = ''
            document.getElementById('closeFileUpload').click()
            this.getDetail()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameUpload)
          }
        })
        .catch((err) => {
          this.showMsgDialog('error', err.message, false)
          this.fileNameUpload = ''
          if (this.$refs.entryFormUpload) {
            this.$refs.entryFormUpload.reset()
          }
        })
      this.isEdit = false
    },
    addItem() {
      setTimeout(() => {
        document.getElementById('addItemUsage').click()
      }, 500)
    },
    initLot(pItem) {
      for (let i = 0; i < pItem.length; i++) {
        console.log(pItem[i])
        const a = {
          // company_id: pItem[i].company_id,
          // company_name: pItem[i].company_name,
          // current_location_name: pItem[i].current_location_name,
          // current_company_name: pItem[i].current_company_name,
          lot_id: Number(pItem[i].id),
          lot_no: pItem[i].name,
          asset_name: pItem[i].asset_name,
          asset_code: pItem[i].asset_code,
          qty_used: parseFloat(pItem[i].qty_used)
        }
        this.result.items.push(a)
      }
      this.createFormAddItem()
    },
    createFormAddItem() {
      const newForm = {
        usage_location: this.result.usage_location,
        planned_date: this.result.planned_date,
        actual_date: this.result.actual_date,
        description: this.result.description,
        company_id: Number(this.result.company_id),
        company_name: this.result.company_name
      }
      if (this.form.items && this.form.items.length > 0) {
        Object.assign(newForm, {
          lot_id: this.form.items[0].lot_id,
          qty_used: this.form.items[0].qty_used
        })
      }
      // if (this.form.company) {
      //   Object.assign(newForm, {
      //     company_id: Number(this.form.company.id),
      //     company_name: this.form.company.name
      //   })
      // }
      // console.log('newForm>>>', newForm)
      // this.save(newForm)
      this.saveItem(newForm)
    },
    saveItem(form) {
      console.log('saveItem', form)
    },
    deleteItem(pItem, index) {
      this.showMsgDialog(
        'question',
        'Lot ini akan dihapus, Anda yakin ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          axios
            .delete(`${this.asset}usage/detail/delete/${pItem.id}`)
            .then((res) => {
              console.log('delete>>>>', res)
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                setTimeout(() => {
                  this.isEdit = false
                  this.getDetail()
                }, 200)
              } else {
                this.showMsgDialog('error', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    async deleteAllItem() {
      this.showMsgDialog(
        'question',
        'Item tersebut akan dihapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          for (let i = 0; i < this.result.items.length; i++) {
            await axios
              .delete(
                `${this.asset}usage/detail/delete/${this.result.items[i].id}`
              )
              .then((res) => {
                console.log('delete>>>>', res)
                if (i == this.result.items.length - 1) {
                  if (res.data.status_code === '00') {
                    this.showMsgDialog('success', res.data.status_msg, false)
                  } else {
                    this.showMsgDialog('error', res.data.status_msg, false)
                  }
                }
                return null
              })
              .catch((err) => {
                if (i == this.result.items.length - 1) {
                  this.showMsgDialog('error', err.message, false)
                }
                return null
              })
          }
          this.getDetail()
        }
      })
    },
    rowClick(pItem) {
      console.log(pItem)
      // setTimeout(() => {
      //   this.$router.push(`/hr/leave/detail/${pItem.id}`)
      // }, 100)
    },
    getDetail() {
      this.loading = true
      console.log('getUserProfile', this.getUserProfile)
      this.result = null
      axios
        .get(`${this.asset}usage/detail/${this.$route.params.id}`)
        .then((res) => {
          console.log('Detail', res)
          this.result = res.data.data
          this.result.items = [
            {
              qty_used: res.data.data.qty_used,
              lot_no: res.data.data.lot_no,
              asset_name: res.data.data.asset_name,
              asset_code: res.data.data.asset_code
            }
          ]
          this.dropdownCompany.push({
            id: Number(res.data.data.company_id),
            name: res.data.data.company_name
          })
          this.authorityCheck(res.data.data)
          this.matrixCheck(res.data.data)
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    // clickOutside() {
    //   this.$emit('close')
    // },
    close() {
      // this.$emit('close')
      // this.dialog = false
      this.$router.push('/asset-management/pemakaian-aset')
    },

    approveUsage() {
      const form = {
        document_id: this.result.approval_matrix[0].document_id,
        status: 1
      }
      this.confirmNow(form)
    },
    rejectUsage() {
      const form = {
        document_id: this.result.approval_matrix[0].document_id,
        status: -1
      }
      this.confirmNow(form)
    },
    confirmNow(form) {
      this.loading = true
      axios
        .post(`${this.asset}usage/confirm`, form)
        .then((res) => {
          if (res.data.status_code == '00') {
            if (form.status == -1) {
              this.showMsgDialog(
                'success',
                'Data has been successfully rejected',
                false
              )
            } else {
              this.showMsgDialog('success', res.data.status_msg, false)
            }
            this.getDetail()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.loading = false
          // this.$emit('loadPage')
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
        })
    },
    authorityCheck(item) {
      if (item.approval_matrix != null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuth}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=18&table_name=${item.approval_matrix[0].table_name}`
          )
          .then((res) => {
            console.log('authorityCheck', res)
            if (res.data.status_code == '00') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllow = true
              } else {
                this.isAllow = false
              }
            } else {
              this.isAllow = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Authority check error, please contact an Admin'
                : 'Authority check error, please contact an Admin',
              false
            )
          })
      }
    },
    matrixCheck(item) {
      if (item.approval_matrix != null) {
        axios
          .get(
            `${this.oAuth}approval_matrix/document/list?limit=100&offset=0&keyword=&application_id=18&table_name=${item.approval_matrix[0].table_name}&document_id=${item.approval_matrix[0].document_id}`
          )
          .then((res) => {
            if (res.data.status_code == '00') {
              this.matrix = res.data.data
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Authority check error, please contact an Admin'
                : 'Authority check error, please contact an Admin',
              false
            )
          })
      }
    },
    fetchApproval() {
      this.matrix = []
      const form = {
        act: 'fetch_matrix',
        document_id: this.$route.params.id,
        document_no: this.result.doc_no,
        application_id: 18,
        table_name: 'ams_tr_assetusages',
        company_id: this.result.company_id
      }
      this.loading = true
      axios
        .post(`${this.oAuth}approval_matrix/document/save`, form)
        .then((res) => {
          // console.log('>>> fetch:', res.data.status_code)
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', 'Fetch matrix success', false)
            this.getDetail()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog('error', res.error_msg[0].msg, false)
            } else {
              this.showMsgDialog('error', res.status_msg, false)
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, please contact an Admin'
              : 'Something went wrong, please contact an Admin',
            false
          )
          this.loading = false
        })
    },
    cancelRequest() {
      this.showMsgDialog('question', 'Lanjutkan', true).then((res) => {
        if (res.isConfirmed) {
          const xArrItem = this.result.items || []
          const xCheckProcessedItem = xArrItem.find(({ status }) => status == 1)
          if (xCheckProcessedItem != undefined) {
            this.showMsgDialog(
              'warning',
              'Tidak dapat dibatalkan, sudah ada item yang diproses',
              false
            )
            return
          }
          const form = {
            id: this.result.id,
            confirm_note: this.reason
          }
          this.loading = true
          axios
            .post(`${this.asset}usage/cancel`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.reason = ''
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.getDetail()
              this.loading = false
              this.dialog2 = false
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    cancelEditHeader() {
      this.isEdit = false
      setTimeout(() => {
        delete this.result.destination
        this.getDetail()
      }, 200)
    },
    editHeader() {
      setTimeout(() => {
        this.isEdit = true
      }, 200)
    },
    saveEditHeader() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin menyimpan data ini ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          const form = {
            act: 'update',
            id: this.result.id,
            usage_location: this.result.usage_location,
            planned_date: this.result.planned_date,
            actual_date: this.result.actual_date,
            description: this.result.description,
            company_id: Number(this.result.company_id),
            company_name: this.result.company_name
          }
          this.loading = true
          axios
            .post(`${this.asset}usage/save`, form)
            .then((res) => {
              this.isEdit = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.getDetail()
              this.loading = false
            })
            .catch((err) => {
              console.log(err)
              this.isEdit = false
              this.loading = false
            })
        }
      })
    },
    submitUsage() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen pemindahan sekarang?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          const form = {
            id: this.result.id
          }
          this.loading = true
          axios
            .post(`${this.asset}usage/submit`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.getDetail()
              this.loading = false
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    setDraft() {
      this.showMsgDialog('question', 'Kembalikan menjadi draft ?', true).then(
        (res) => {
          if (res.isConfirmed) {
            const form = {
              id: this.result.id
            }
            this.loading = true
            axios
              .post(`${this.asset}usage/set_to_draft`, form)
              .then((res) => {
                if (res.data.status_code == '00') {
                  this.reason = ''
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
                this.getDetail()
                this.loading = false
              })
              .catch((err) => {
                console.log(err)
                this.loading = false
              })
          }
        }
      )
    },
    convertDate(val) {
      const raw = val
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      }
    },
    headTable(v) {
      switch (v) {
        case 1:
          return this.headers
        case 2:
          if (
            this.getUserProfile.employee.company.plant_id ==
            this.result.company_id
          ) {
            return this.headers2
          }
          return this.headers3
        default:
          return this.headers
      }
    },
    itemStatus(v) {
      switch (v) {
        case -1:
          return 'Unreceived'
        case 0:
          return 'Pending'

        case 1:
          return 'Received'
        default:
          return 'null'
      }
    },
    color(v) {
      switch (v) {
        case -1:
          return 'red'

        case 0:
          return 'grey'

        case 1:
          return 'green'

        default:
          return 'black'
      }
    },
    color2(v) {
      switch (v) {
        case -1:
          return 'hsla(10, 90%, 60%, 0.3)'

        case 1:
          return 'hsla(100, 50%, 50%, 0.3)'

        default:
          return 'white'
      }
    },
    statusColor(val) {
      let color = null
      if (val < 0) {
        color = 'red'
      } else {
        const arrType = ['grey', 'orange', 'green']
        color = arrType[val]
      }
      return color
    },
    usageStatus(v) {
      switch (v) {
        case -2:
          return 'Canceled'
        case -1:
          return 'Rejected'

        case 0:
          return 'Draft'

        case 1:
          return 'Waiting Approval'

        case 2:
          return 'Confirmed'

        default:
          return '-'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap
  padding: 10px
</style>
